import { Component, OnInit } from '@angular/core';
import { CommonProjectDataService } from "../../_services/common-project-data.service";
import { CommonService } from "../../_services/common.service";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl
}
  from "@angular/forms";
import { FlashMessagesService } from "angular2-flash-messages";
import { MatDialog } from "@angular/material";
import { Router } from '@angular/router';
import { ProductDetailComponent } from '../product-detail/product-detail.component';
import { OverrideStockComponent } from '../override-stock/override-stock.component';
import { SettingService } from '../../_services/setting.service';

@Component({
  selector: 'app-product-quantity',
  templateUrl: './product-quantity.component.html',
  styleUrls: ['./product-quantity.component.css']
})
export class ProductQuantityComponent implements OnInit {
  productQuantityForm: FormGroup;
  public activeProjectIndex = "";
  public projects: any = {};
  public currentActiveColor = null;
  public currentActiveColorObj: any = {};
  public selectedProductColors = {};
  public isAlreadyExist = false;
  public isQuantityValidated = false;
  public total_item_qty = 0;
  public total_item_price = 0;
  public isValidData = true;
  public totalProjectQuantity: any = [];
  tempProjectData: any;
  public min_order_qty = 0;
  public grandTotalPrice = 0;
  public isLessOrderLimit = 0
  public orderType: string;
  public prevPrice: number;
  public isTurnOffPriceView = false;
  public isTurnOffImpressionCost = false;
  public isturnOffSSInventory = false;
  public productMatrix: any = [];
  public isPublicQuoteCreation = false;
  selectedMatrix_id: any;
  redirectClick: any;
  public qty: any = [];
  public disabled: false;
  public userDetails: any = {};
  public isCustomer = false;
  public priceOverrideLoading = false;
  public priceOverrideLocation: any = {};
  constructor(private CommonProjectDataService: CommonProjectDataService,
    private CommonService: CommonService,
    private fb: FormBuilder,
    private _flashMessagesService: FlashMessagesService,
    private dialog: MatDialog,
    private router: Router,
    private settingService: SettingService
  ) {
    this.productQuantityForm = fb.group({
      productQuantityItems: fb.array([])
    });
    this.isPublicQuoteCreation = localStorage.getItem('isPublicQuoteCreation') === 'Yes' ? true : false;
    this.isAccessInvoiceType();
  }

  ngOnInit() {
    this.userDetails = JSON.parse(localStorage.getItem("userDetails"));
    this.isCustomer = this.userDetails.type == 'Printer' || this.userDetails.type == 'Designer' ? true : false;
    this.orderType = this.CommonProjectDataService.getOrderType();
    this.activeProjectIndex = this.CommonProjectDataService.getActiveProjectIndex();
    this.projects = JSON.parse(JSON.stringify(this.CommonProjectDataService.get()));
    this.isQuantityValidated = JSON.parse(JSON.stringify(this.CommonProjectDataService.getQuantityValidated()));
    this.selectedProductColors = this.CommonProjectDataService.getProductColor() ? JSON.parse(JSON.stringify(this.CommonProjectDataService.getProductColor())) : {};
    this.totalProjectQuantity = JSON.parse(JSON.stringify(this.CommonProjectDataService.getTotalProjectQuantity()));
    this.grandTotalPrice = JSON.parse(JSON.stringify(this.CommonProjectDataService.getTotalPrice()));
    this.min_order_qty = this.CommonProjectDataService.getMinOrderQty();
    this.isLessOrderLimit = this.CommonProjectDataService.getIsLessOrderLimit();
    this.prevPrice = JSON.parse(localStorage.getItem('prevPrice'));
    this.isTurnOffPriceView = this.CommonProjectDataService.getTurnOffPriceView();
    this.isTurnOffImpressionCost = this.CommonProjectDataService.getTurnOffImpressionCost();
    this.isturnOffSSInventory = this.CommonProjectDataService.getTurnOffSSInventory();
    this.getProductMatrix('all');
    this.getMinQty();
    this.productMatrix = this.CommonProjectDataService.getProductMatrix();
    this.showConfirmMessage();
    this.CommonProjectDataService.storeCurrentIndexForStep(2);
  }
  trackByFn(index: any, item: any) {
    return index;
  }

  checkSelectedColor(colorID, matrix) {
    let is_selected = false;
    matrix.forEach(function (value, key) {
      if (colorID == value.color.color_id) {
        is_selected = true;
      }
    });
    return is_selected;
  }

  handleColorImage(colorId, productDetail, colorObj) {
    this.currentActiveColor = colorId;
    this.currentActiveColorObj = colorObj;
    this.projects.projects_data[this.activeProjectIndex].selectedProductColors = this.selectedProductColors;
    //check already exits
    if (this.selectedProductColors[this.activeProjectIndex] && this.selectedProductColors[this.activeProjectIndex][productDetail.product_id].indexOf(colorId) >= 0) {
      this.isAlreadyExist = true;
    }
    else {
      this.isAlreadyExist = false;
    }
    if (this.projects.projects_data[this.activeProjectIndex].active_location_arr && this.projects.projects_data[this.activeProjectIndex].active_location_arr.length > 0) {
      let tmpTotalChangedColor = [];
      this.projects.projects_data[this.activeProjectIndex].active_location_arr.map((cLocs) => {
        let isInkChangeDataEmpty = this.isObjectEmpty(this.projects.projects_data[this.activeProjectIndex].inkChangeData[cLocs]);
        if (!isInkChangeDataEmpty && this.projects.projects_data[this.activeProjectIndex].inkChangeData[cLocs]['updData'] && this.projects.projects_data[this.activeProjectIndex].inkChangeData[cLocs]['updData'].length > 0) {
          this.projects.projects_data[this.activeProjectIndex].inkChangeData[cLocs]['updData'].map(subArr => {
            if (subArr.length > 0) {
              tmpTotalChangedColor = tmpTotalChangedColor.concat(subArr);
            }
          });
        }
      });
      if (tmpTotalChangedColor.length > 0) {
        let isChangeOut = [];
        isChangeOut = tmpTotalChangedColor.filter(function (compData) {
          return (compData.color.color_id == colorId) ? colorId : null;
        });

        if (isChangeOut.length > 0) {
          this._flashMessagesService.show("Can't Remove : You have Ink Change-Out settings present for this Color", { cssClass: 'alert-warning', timeout: 5000 });
          return true;
        }
      }
    }

    if (!this.isAlreadyExist || this.selectedProductColors[this.activeProjectIndex][productDetail.product_id].length > 1) {
      this.manageSelectedColors(this.isAlreadyExist, productDetail);
    }
  }

  manageSelectedColors(isAlreadyExist, productDetails) {
    let currentActiveColor = this.currentActiveColor;
    let currentActiveColorObj = this.currentActiveColorObj;
    let activeIndex = this.activeProjectIndex;
    let matrix_id;
    this.productMatrix[productDetails.type].forEach((value, key) => {
      if (value.is_default == "1") {
        matrix_id = value.matrix_id;
      }
    });

    if (currentActiveColor) {
      //handle projects
      if (isAlreadyExist) {
        let projects = this.projects;
        projects.projects_data[this.activeProjectIndex]['products'].forEach((value, key) => {
          if (value.product_id == productDetails.product_id) {
            projects.projects_data[activeIndex]['products'][key].matrix.forEach((ivalue, ikey) => {
              if (ivalue.color.color_id == currentActiveColor) {
                // manage custom product inventory
                projects.projects_data[activeIndex]['products'][key].matrix.splice(ikey, 1);
              }
            });
          }
        });
        this.projects = projects;
        if (this.grandTotalPrice > 0) {
          this.manageTotalQty();
        }
      }
      else {

        if (!this.projects.projects_data[this.activeProjectIndex]['products']) {
          this.projects.projects_data[this.activeProjectIndex]['products'] =
            [{
              'product_id': productDetails.product_id,
              'productDetail': productDetails,
              'matrix': [{
                'color': currentActiveColorObj,
                'matrix_id': matrix_id,
                'size': productDetails.sizes,
                'quantity': new Array(productDetails.sizes.length).fill(null),
                'verify_quantity': new Array(productDetails.sizes.length).fill(null),
                'price': new Array(productDetails.sizes.length).fill(null),
                'item_price': new Array(productDetails.sizes.length).fill(null),
                'impression_price': new Array(productDetails.sizes.length).fill(null),
                'total_price': new Array(productDetails.sizes.length).fill(null),
                'set_total_price': new Array(productDetails.sizes.length).fill(null),
              }]
            }];
        }
        else {
          var tmp_data = null;
          var tmp_key = null;
          var other_product = null;
          if (this.selectedProductColors[this.activeProjectIndex] && this.selectedProductColors[this.activeProjectIndex][productDetails.product_id].indexOf(this.currentActiveColor) < 0) {
            var selectedProductIds = this.projects.projects_data[this.activeProjectIndex]['products'].map(function (id) {
              return id.product_id;
            });
            var findProductIdIndex = selectedProductIds.indexOf(productDetails.product_id);
            if (findProductIdIndex >= 0) {
              this.projects.projects_data[this.activeProjectIndex]['products'][findProductIdIndex].matrix.forEach(function (ivalue, ikey) {
                if (ivalue.color.color_id != currentActiveColor) {
                  tmp_key = findProductIdIndex;
                  tmp_data = {
                    'color': currentActiveColorObj,
                    'matrix_id': matrix_id,
                    'size': productDetails.sizes,
                    'quantity': new Array(productDetails.sizes.length).fill(null),
                    'verify_quantity': new Array(productDetails.sizes.length).fill(null),
                    'price': new Array(productDetails.sizes.length).fill(null),
                    'item_price': new Array(productDetails.sizes.length).fill(null),
                    'impression_price': new Array(productDetails.sizes.length).fill(null),
                    'total_price': new Array(productDetails.sizes.length).fill(null),
                    'set_total_price': new Array(productDetails.sizes.length).fill(null),
                  };
                }
              });
              other_product = null;
            }
            else {
              other_product = {
                'product_id': productDetails.product_id,
                'productDetail': productDetails,
                'matrix': [{
                  'color': currentActiveColorObj,
                  'matrix_id': matrix_id,
                  'size': productDetails.sizes,
                  'quantity': new Array(productDetails.sizes.length).fill(null),
                  'verify_quantity': new Array(productDetails.sizes.length).fill(null),
                  'price': new Array(productDetails.sizes.length).fill(null),
                  'item_price': new Array(productDetails.sizes.length).fill(null),
                  'impression_price': new Array(productDetails.sizes.length).fill(null),
                  'total_price': new Array(productDetails.sizes.length).fill(null),
                  'set_total_price': new Array(productDetails.sizes.length).fill(null),
                }]
              };
            }
            if (tmp_data) {
              this.projects.projects_data[this.activeProjectIndex]['products'][tmp_key].matrix.push(tmp_data);
            }
            if (other_product) {
              this.projects.projects_data[this.activeProjectIndex]['products'].push({
                'product_id': productDetails.product_id,
                'productDetail': productDetails,
                'matrix': [{
                  'color': currentActiveColorObj,
                  'matrix_id': matrix_id,
                  'size': productDetails.sizes,
                  'quantity': new Array(productDetails.sizes.length).fill(null),
                  'verify_quantity': new Array(productDetails.sizes.length).fill(null),
                  'price': new Array(productDetails.sizes.length).fill(null),
                  'item_price': new Array(productDetails.sizes.length).fill(null),
                  'impression_price': new Array(productDetails.sizes.length).fill(null),
                  'total_price': new Array(productDetails.sizes.length).fill(null),
                  'set_total_price': new Array(productDetails.sizes.length).fill(null),
                }]
              });
            }
          }
        }
      }
      let tmpColorArr = this.selectedProductColors[this.activeProjectIndex][productDetails.product_id];
      if (tmpColorArr.length > 0) {
        if (tmpColorArr.indexOf(this.currentActiveColor) < 0) {
          tmpColorArr.push(this.currentActiveColor);
        }
        else {
          let s_p_index = tmpColorArr.indexOf(this.currentActiveColor);
          tmpColorArr.splice(s_p_index, 1);
          this.isAlreadyExist = false;
          this.currentActiveColor = null;
        }
      }
      else {
        tmpColorArr = [this.currentActiveColor];
      }

      this.selectedProductColors[this.activeProjectIndex][productDetails.product_id] = tmpColorArr;
      this.CommonProjectDataService.storeProductColor(this.selectedProductColors);
      this.CommonProjectDataService.store(this.projects);
    }
  }

  isColorInkChanged() {
    let isColorInkChanged = false;
    //check if ink change  out setting for color
    if (this.projects.projects_data[this.activeProjectIndex].active_location_arr && this.projects.projects_data[this.activeProjectIndex].active_location_arr.length > 0) {
      let tmpTotalChangedColor = [];
      this.projects.projects_data[this.activeProjectIndex].active_location_arr.map((cLocs) => {
        let isInkChangeDataEmpty = true;
        isInkChangeDataEmpty = this.isObjectEmpty(this.projects.projects_data[this.activeProjectIndex].inkChangeData[cLocs]);
        if (!isColorInkChanged && !isInkChangeDataEmpty && this.projects.projects_data[this.activeProjectIndex].inkChangeData[cLocs]['colorChange'] && !this.isObjectEmpty(this.projects.projects_data[this.activeProjectIndex].inkChangeData[cLocs]['colorChange'])) {
          let tmpColorChange = this.projects.projects_data[this.activeProjectIndex].inkChangeData[cLocs]['colorChange'];
          isColorInkChanged = true;
        }
      });

      if (isColorInkChanged) {
        this._flashMessagesService.show("Can't Remove : You have Ink Change-Out settings present for this Color", { cssClass: 'alert-warning', timeout: 5000 });
        isColorInkChanged = true;
      }
    }
    return isColorInkChanged;
  }

  removeGarments(pindex, dindex) {
    if (!this.isColorInkChanged()) {
      if (this.projects.projects_data[pindex].products.length <= 1) {
        this.projects.projects_data[pindex]['products'] = [];
        this.projects.projects_data[pindex]['ink_Details'] = {};
        this.projects.projects_data[pindex]['artwork'] = {};
        this.projects.projects_data[pindex]['inkColorObj'] = {};
        this.projects.projects_data[pindex]['inkColors'] = {};
        this.projects.projects_data[pindex]['active_location_arr'] = [];
        this.projects.projects_data[pindex]['printPositionSetting'] = {};
        this.projects.projects_data[pindex]['printAddonSwatchSettingObj'] = {};
        this.projects.projects_data[pindex]['printAddonSettingObj'] = {};
        this.projects.projects_data[pindex]['printAddonInputSettingObj'] = {};
        this.projects.projects_data[pindex]['printAddonSetting'] = {};
        this.projects.projects_data[pindex]['inkChangeObj'] = {};
        this.projects.projects_data[pindex]['inkChangeData'] = {};
        this.projects.projects_data[pindex].totalProjectQuantity = 0;
        this.grandTotalPrice = 0;
        this.projects.grand_total_price = 0;
        this.projects.total_price = 0;
        this.projects.total_quantity = [];
        this.CommonProjectDataService.storeTotalPrice(this.grandTotalPrice);
        this.CommonProjectDataService.storeTotalProjectQuantity(this.projects.total_quantity);
        this.CommonProjectDataService.storeProductColor({});
        this.CommonProjectDataService.store(this.projects);
      }
      else {
        let productId = this.projects.projects_data[pindex]['products'][dindex].product_id;
        //manage inventory
        if (this.projects.projects_data[pindex].selectedProductColors) {
          delete this.projects.projects_data[pindex].selectedProductColors[pindex][productId];
        }
        this.projects.projects_data[pindex].products.splice(dindex, 1);
        this.manageTotalQty();
        this.CommonProjectDataService.store(this.projects);
      }
      if (this.projects.projects_data[0].products.length === 0) {
        this.redirectClick = "allProductDeleted";
      }
    }
  }

  manageTotalQty() {
    var tmp_total_qty = 0;
    var tmp_total_price = 0;
    var product_total_quantity = 0;
    this.isValidData = true;

    this.CommonProjectDataService.storeQuantityValidated(true);
    this.projects.projects_data.forEach((pvalue, pkey) => {
      this.totalProjectQuantity[pkey] = 0;
      if (pvalue.products && pvalue.products.length > 0) {
        pvalue.products.forEach((mvalue, mkey) => {
          this.isLessOrderLimit = this.projects.projects_data[pkey]['products'][mkey].productDetail.less_order_limit;
          var tmp_total_qty = 0;
          mvalue.matrix.forEach((svalue, skey) => {
            tmp_total_qty = tmp_total_qty + this.totalQuantity(svalue.quantity);
            product_total_quantity = product_total_quantity + this.totalQuantity(svalue.quantity);
            this.totalProjectQuantity[pkey] = this.totalProjectQuantity[pkey] + this.totalQuantity(svalue.quantity);
            if (this.totalQuantity(svalue.quantity)) {
              this.projects.projects_data[pkey]['products'][mkey].matrix[skey].total_color_quantity = this.totalQuantity(svalue.quantity);
              this.projects.projects_data[pkey]['products'][mkey].product_total_quantity = tmp_total_qty;
            }
          });
          if (this.isLessOrderLimit == 1 && this.isQuantityValidated) {
            if (tmp_total_qty <= 0) {
              this.isValidData = false;
              this.CommonProjectDataService.storeQuantityValidated(false);
            }
          }
          if (this.isLessOrderLimit == 0) {
            if (this.totalProjectQuantity[pkey] < this.min_order_qty) {
              this.isValidData = false;
              this.CommonProjectDataService.storeQuantityValidated(false);
            }
            else {
              this.isValidData = true;
              this.CommonProjectDataService.storeQuantityValidated(true);
            }
          }
        });
      }
      this.projects.projects_data[pkey].totalProjectQuantity = this.totalProjectQuantity[pkey];
    });
    this.total_item_price = tmp_total_price;
    this.total_item_qty = product_total_quantity;
    this.CommonProjectDataService.store(this.projects);
    this.CommonProjectDataService.storeTotalProjectQuantity(this.totalProjectQuantity);
    this.tempProjectData = JSON.parse(JSON.stringify(this.projects.projects_data));
    if (product_total_quantity >= 0) {
      this.getPrice(this.tempProjectData);
    } else {
      this.openPriceOverride();
    }
  }

  openPriceOverride() {
    this.priceOverrideLoading = false;
    if (Object.keys(this.priceOverrideLocation).length > 0) {
      if (this.projects.projects_data[this.activeProjectIndex]) {
        if (this.projects.projects_data[this.activeProjectIndex].products[this.priceOverrideLocation.productIndex]) {
          if (this.projects.projects_data[this.activeProjectIndex].products[this.priceOverrideLocation.productIndex].matrix[this.priceOverrideLocation.matrixIndex]) {
            this.projects.projects_data[this.activeProjectIndex].products[this.priceOverrideLocation.productIndex].matrix[this.priceOverrideLocation.matrixIndex].openPriceEditLoader = new Array(this.projects.projects_data[this.activeProjectIndex].products[this.priceOverrideLocation.productIndex].matrix[this.priceOverrideLocation.matrixIndex].size.length).fill(null);
          }
        }
      }
      this.priceOverrideLocation = {};
    }
  }

  totalQuantity(rowArr) {
    if (Object.keys(rowArr).length > 0) {
      return rowArr.reduce(function (a, b) {
        let aVal = (a) ? a : 0;
        let bVal = (b) ? b : 0;
        return aVal + bVal;
      }, 0);
    }
    else {
      return 0;
    }
  }

  checkProductQty(colorID, sizeID, otherOpt, type) {
    var is_disable = false;
    if (type != 'custom' && type != 'quickItem') {
      if (otherOpt === undefined || otherOpt.quantity === undefined || otherOpt.quantity == 0) {
        is_disable = true;
      }
    }
    else {
      if ((type == 'custom' || type == 'quickItem') && otherOpt !== undefined && (otherOpt.quantity === '' || otherOpt.quantity === null)) {
        is_disable = false;
      }
      else {
        if (otherOpt === undefined || otherOpt.quantity === undefined || otherOpt.quantity == 0) {
          is_disable = true;
        }
      }
    }
    return is_disable;
  }

  validateProductQty(enteredQty, allowedQty, isLessOrderLimit, pikey, pmkey, pOptions, pColorId, pSizeId, pIndex, productId) {
    if (enteredQty == null) {
      return;
    }
    if (pOptions[pColorId][pSizeId]) {
      this.projects.projects_data[this.activeProjectIndex].products[pikey].matrix[pmkey].price[pIndex] = (pOptions[pColorId][pSizeId].price) ? pOptions[pColorId][pSizeId].price : 0;
    }
    else {
      this.projects.projects_data[this.activeProjectIndex].products[pikey].matrix[pmkey].price[pIndex] = 0;
    }

    // Tiny loader while updating pricing
    this.projects.projects_data[this.activeProjectIndex].products[pikey].matrix[pmkey].openPriceEditLoader = new Array(this.projects.projects_data[this.activeProjectIndex].products[pikey].matrix[pmkey].size.length).fill(null);
    this.projects.projects_data[this.activeProjectIndex].products[pikey].matrix[pmkey].openPriceEditLoader[pIndex] = true;
    this.priceOverrideLocation = {
      productIndex: pikey,
      matrixIndex: pmkey,
      sizeIndex: pIndex
    };
    this.priceOverrideLoading = true;

    let type = this.projects.projects_data[this.activeProjectIndex].products[pikey].productDetail.type;
    if (isLessOrderLimit == 1 && enteredQty > 0) {
      this.isValidData = true;
      this.CommonProjectDataService.storeQuantityValidated(true);
    }
    else {
      // same color in multiple project
      let totalBalance = 0;
      let isproducExist = false;
      if (this.projects.projects_data.length > 1) {
        for (let i = 0; i < this.projects.projects_data[this.activeProjectIndex].length; i++) {
          if (this.projects.projects_data[i].products && this.projects.projects_data[i].products != undefined && this.projects.projects_data[i].products.length > 0) {
            let products = this.projects.projects_data[i].products.find(x => x.product_id === productId);
            if (products) {
              for (let m = 0; m < products.matrix.length; m++) {
                if (products.matrix[m].color.color_id == pColorId) {
                  isproducExist = true;
                  totalBalance += products.matrix[m].quantity[pIndex];
                }
                else {
                  isproducExist = false;
                  totalBalance = 0;
                }
              }
            }
          }
        }
      }
      let totalEnteredQty = isproducExist == true ? totalBalance : enteredQty;
      //end
      if (totalEnteredQty > allowedQty || !totalEnteredQty) {
        this.CommonProjectDataService.storeQuantityValidated(false);
      }
      else {
        this.isValidData = true;
      }
    }
    this.manageTotalQty();
  }

  validateProductQtyPopup(enteredQty, allowedQty, isLessOrderLimit, pikey, pmkey, pOptions, pColorId, pSizeId, pIndex, productId) {
    this.projects.projects_data[this.activeProjectIndex].products[pikey].matrix[pmkey].price[pIndex] = (pOptions[pColorId][pSizeId].price) ? pOptions[pColorId][pSizeId].price : 0;
    let type = this.projects.projects_data[this.activeProjectIndex].products[pikey].productDetail.type;
    if (isLessOrderLimit == 1 && enteredQty > 0) {
      this.isValidData = true;
      this.CommonProjectDataService.storeQuantityValidated(true);
    }
    else {
      // same color in multiple project
      let totalBalance = 0;
      let isproducExist = false;
      if (this.projects.projects_data.length > 1) {
        for (let i = 0; i < this.projects.projects_data[this.activeProjectIndex].length; i++) {
          if (this.projects.projects_data[i].products && this.projects.projects_data[i].products != undefined && this.projects.projects_data[i].products.length > 0) {
            let products = this.projects.projects_data[i].products.find(x => x.product_id === productId);
            if (products) {
              for (let m = 0; m < products.matrix.length; m++) {
                if (products.matrix[m].color.color_id == pColorId) {
                  isproducExist = true;
                  totalBalance += products.matrix[m].quantity[pIndex];
                }
                else {
                  isproducExist = false;
                  totalBalance = 0;
                }
              }
            }
          }
        }
      }
      let totalEnteredQty = isproducExist == true ? totalBalance : enteredQty;
      //end
      if (totalEnteredQty > allowedQty || !totalEnteredQty) {
        if (type != 'custom' && type != 'quickItem') {
          if (totalEnteredQty != 0 && totalEnteredQty != '') {
            const dialogRef = this.dialog.open(OverrideStockComponent, {
              width: "50%",
              maxWidth: "none",
              disableClose: true,

            });

            dialogRef.afterClosed().subscribe(result => {
              if (result != 'ok') {
                this.projects.projects_data[this.activeProjectIndex].products[pikey].matrix[pmkey].quantity[pIndex] = 0;
                this.isValidData = false;
              }
              else {
                this.isValidData = true;
              }
            });
          }
          else {
            this.projects.projects_data[this.activeProjectIndex].products[pikey].matrix[pmkey].quantity[pIndex] = 0;
            this.isValidData = false;
          }
        }
        else {
          if ((type == 'custom' || type == 'quickItem') && (allowedQty === '' || allowedQty === null)) {
            this.isValidData = true;
          }
          else {
            this.projects.projects_data[this.activeProjectIndex].products[pikey].matrix[pmkey].quantity[pIndex] = 0;
            this.isValidData = false;
          }
        }
        this.CommonProjectDataService.storeQuantityValidated(false);
      }
      else {
        this.isValidData = true;
      }
    }
  }

  changeProductMatrix(matrix_id, pikey, pmkey, pOptions, pColorId, productId) {
    if (!this.projects.projects_data[this.activeProjectIndex]['products'][pikey].matrix[pmkey].quantity.some(value => value !== null)) {
      this._flashMessagesService.show("Please set quantity before apply matrix.", { cssClass: 'alert-warning', timeout: 5000 });
      return false;
    }
    this.projects.projects_data[this.activeProjectIndex]['products'][pikey].matrix[pmkey].matrix_id = matrix_id;
    this.manageTotalQty();
  }

  getPrice = function (datarecord) {
    this.disabled = true;
    this.loading = true;
    let projects = datarecord;
    let user_id = this.projects.user_id;
    let finalArr = []
    projects.forEach((pvalue, pkey) => {
      let activeLoc = pvalue.active_location_arr;
      let projectTitle = (pvalue.projectTitle) ? pvalue.projectTitle : "";
      if (sessionStorage.getItem(`projectTitle_${pkey}`)) {
        projectTitle = sessionStorage.getItem(`projectTitle_${pkey}`);
      }
      let isCheckedProjectTab = (pvalue.isCheckedProjectTab) ? pvalue.isCheckedProjectTab : "";
      let totalPriceCalculation = (pvalue.totalPriceCalculation) ? pvalue.totalPriceCalculation : false;
      if (pvalue.products && pvalue.products.length > 0) {
        pvalue.products.forEach((product, key) => {
          if (finalArr[pkey] && finalArr[pkey].products) {
            Object.assign(finalArr[pkey].products, { [product.product_id]: {} });
            Object.assign(finalArr[pkey].products_matrix, { [product.product_id]: {} });
          }
          else {
            finalArr[pkey] = {
              'products': { [product.product_id]: {} },
              'products_matrix': { [product.product_id]: {} },
              'printPositionSetting': pvalue.printPositionSetting,
              'finishingDetails': (pvalue.finishing_type_id) ? pvalue.finishing_type_id : [],
              'inkDetail': (pvalue.ink_Details && pvalue.ink_Details.ink_type_id) ? pvalue.ink_Details.ink_type_id : null,
              'section_items': pvalue.section_items,
              'isCheckedProjectTab': isCheckedProjectTab,
              'projectTitle': projectTitle,
              'productsMatrixData': pvalue.products,
              'totalPriceCalculation': totalPriceCalculation
            };
          }
          finalArr[pkey].ownGarmentsWeight = pvalue.ownGarmentsWeight;

          // set inkColors under printPositionSetting
          if (activeLoc && activeLoc.length > 0) {
            activeLoc.forEach((lval, lkey) => {

              if (pvalue.inkColors && pvalue.inkColors[lval.emblocation_id]) {
                let tmpInkColor = (pvalue.inkColors[lval.emblocation_id]) ? pvalue.inkColors[lval.emblocation_id] : [];
                if (pvalue.printPositionSetting[lval.emblocation_id]) {
                  pvalue.printPositionSetting[lval.emblocation_id]['inkColors'] = tmpInkColor;
                }
                else {
                  pvalue.printPositionSetting[lval.emblocation_id] = { ['inkColors']: tmpInkColor };
                }
              }
              // set printAddonSetting under printPositionSetting
              if (pvalue.printAddonSetting) {
                if (pvalue.printPositionSetting[lval.emblocation_id]) {
                  pvalue.printPositionSetting[lval.emblocation_id]['printAddonSetting'] = (pvalue.printAddonSetting[lval.emblocation_id]) ? pvalue.printAddonSetting[lval.emblocation_id] : {};
                }
              }

              // set inkChangeData under printPositionSetting
              if (pvalue.inkChangeData) {
                if (pvalue.printPositionSetting[lval.emblocation_id]) {

                  if (pvalue.inkChangeData[lval.emblocation_id]) {
                    pvalue.printPositionSetting[lval.emblocation_id]['inkChangeData'] = this.processInkChangeData(pvalue.inkChangeData[lval.emblocation_id]);
                  }
                  else {
                    pvalue.printPositionSetting[lval.emblocation_id]['inkChangeData'] = [];
                  }

                }
              }
              if (pvalue.artwork) {
                let artTmp = Object.keys(pvalue.artwork).length;
                if (pvalue.artwork && artTmp > 0) {
                }
              }
              finalArr[pkey].printPositionSetting = pvalue.printPositionSetting;
              product.matrix.forEach(function (mval, mkey) {
                if (finalArr[pkey].products[product.product_id]) {
                  Object.assign(finalArr[pkey].products[product.product_id], { [mval.color.color_id]: {}, type: product.productDetail.type });
                  Object.assign(finalArr[pkey].products_matrix[product.product_id], { [mval.color.color_id]: mval.matrix_id });
                }
                else {
                  finalArr[pkey].products[product.product_id] = { [mval.color.color_id]: {}, type: product.productDetail.type };
                  finalArr[pkey].products_matrix[product.product_id] = { [mval.color.color_id]: mval.matrix_id };
                }
                mval.quantity.forEach(function (qval, qkey) {
                  if (qval != null && qval >= 0) {
                    if (finalArr[pkey].products[product.product_id][mval.color.color_id]) {
                      Object.assign(finalArr[pkey].products[product.product_id][mval.color.color_id], { [mval.size[qkey].size_id]: qval });
                    }
                    else {
                      finalArr[pkey].products[product.product_id][mval.color.color_id] = { [mval.size[qkey].size_id]: qval };
                    }
                  }
                });
              });
            });
          }
          else {
            product.matrix.forEach(function (mval, mkey) {
              if (finalArr[pkey].products[product.product_id]) {
                Object.assign(finalArr[pkey].products[product.product_id], { [mval.color.color_id]: {}, type: product.productDetail.type });
                Object.assign(finalArr[pkey].products_matrix[product.product_id], { [mval.color.color_id]: mval.matrix_id });
              }
              else {
                finalArr[pkey].products[product.product_id] = { [mval.color.color_id]: {}, type: product.productDetail.type };
                finalArr[pkey].products_matrix[product.product_id] = { [mval.color.color_id]: mval.matrix_id };
              }
              mval.quantity.forEach(function (qval, qkey) {
                if (qval != null && qval >= 0) {
                  if (finalArr[pkey].products[product.product_id][mval.color.color_id]) {
                    Object.assign(finalArr[pkey].products[product.product_id][mval.color.color_id], { [mval.size[qkey].size_id]: qval });
                  }
                  else {
                    finalArr[pkey].products[product.product_id][mval.color.color_id] = { [mval.size[qkey].size_id]: qval };
                  }
                }
              });
            });
          }
        });
      }
    });
    this.address_id = (this.projects.shipping_address && this.projects.shipping_address.address_id) ? this.projects.shipping_address.address_id : this.projects.address_id ? this.projects.address_id : '';
    let otherData = {
      user_id: this.projects.user_id ? this.projects.user_id : '',
      address_id: this.address_id,
      turn_around_time: this.projects.turn_around_time_key ? this.projects.turn_around_time_key : 0,
      shipping_method: this.projects.shipping_method_key == "null" ? "" : this.projects.shipping_method_key
    }
    let quoteOpt = {
      id: localStorage.getItem("userID"),
      projects_data: finalArr,
      user_id: otherData.user_id,
      address_id: otherData.address_id,
      turn_around_time: otherData.turn_around_time,
      shipping_method: otherData.shipping_method,
      one_time_discount_type: this.projects.one_time_discount_type ? this.projects.one_time_discount_type : '',
      one_time_discount: this.projects.one_time_discount ? this.projects.one_time_discount : 0
    };
    this.CommonService.apiService(
      "POST",
      "v3/order/get_prices",
      quoteOpt
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          this.grandTotalPrice = response.data.grand_total_price;
          this.CommonProjectDataService.storeTotalPrice(response.data.grand_total_price);
          if(this.orderType == 'Quote'){
            this.projects.delivery_date = response.data.delivery_date;
          }
          this.projects.delivery_days = response.data.delivery_days;
          this.projects.discount = response.data.discount;
          this.projects.discount_percentage = response.data.discount_percentage;
          this.projects.grand_total_price = response.data.grand_total_price;
          this.projects.shipping_price = response.data.shipping_price;
          this.projects.tax = response.data.tax;
          this.projects.tax_percentage = response.data.tax_percentage;
          this.projects.total_price = response.data.total_price;
          this.projects.total_printing_price = response.data.total_printing_price;
          this.projects.total_products_price = response.data.total_products_price;
          this.projects.total_quantity = response.data.total_quantity;
          this.projects.total_weight = response.data.total_weight;
          this.projects.turn_around_time_price = response.data.turn_around_time_price;
          this.projects.total_projects = response.data.total_projects;
          this.projects.total_custom_items_price = response.data.total_custom_items_price;
          this.projects.turn_around_time = '0';

          this.projects.one_time_discount = response.data.one_time_discount;
          this.projects.one_time_discount_type = response.data.one_time_discount_type;
          this.projects.one_time_discounted_amt = response.data.one_time_discounted_amt;
          // set  printing price  per project
          this.projects.projects_data[this.activeProjectIndex].total_printing_price = response.data.projects[this.activeProjectIndex].total_printing_price;

          this.projects.projects_data[this.activeProjectIndex].priceMarkupProduct = response.data.projects[this.activeProjectIndex].priceMarkupProduct;

          response.data.projects.forEach((projectValues, projectIndexing) => {
            this.projects.projects_data[projectIndexing].perProjectTotalCost = projectValues.perProjectTotalCost;
            this.projects.projects_data[projectIndexing].products = projectValues.productsMatrixData;
            this.projects.projects_data[projectIndexing].priceDistributionData = projectValues.perProductPriceDistributionData;
            this.projects.projects_data[projectIndexing].projectTitle = projectValues.projectTitle;
          });
          if (otherData.shipping_method == "" || otherData.shipping_method == "local_pickup") {
            this.projects.shipping_method = response.data.shipping_methods.local_pickup;
          }
          this.openPriceOverride();
          this.loading = false;
          this.showConfirmMessage();
        }
        this.disabled = false;
      },
      err => {
        this.loading = false;
        console.log("error msg", err.error.message);
        this.disabled = false;
      }

    );
  }

  showProductDetail(productId, selectedProductColor): void {
    if(this.userDetails.type != 'Printer' && this.userDetails.type != 'Designer'){
      let productPrices = (this.CommonProjectDataService.getSelectedProductPrice());
      let price = productPrices[productId];
      const dialogRef = this.dialog.open(ProductDetailComponent, {
        width: "90%",
        maxWidth: "none",
        disableClose: true,
        data: {
          productId: productId,
          price: price,
          pageType: "Quantity",
          selectedProductColor: selectedProductColor
        }
      });
    }
  }

  openOverrideStock(): void {
    const dialogRef = this.dialog.open(OverrideStockComponent, {
      width: "90%",
      maxWidth: "none",
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe(result => {

    });
  }

  processInkChangeData(inkData) {
    let tmpArr = [];
    inkData.updData.forEach((val, key) => {
      tmpArr[key] = { 'inkColors': [] };
    });
    Object.values(inkData.colorChange).forEach((val, key) => {
      Object.entries(val).forEach(
        ([pkey, value]) => {
          if (tmpArr[key].inkColors) {
            tmpArr[key].inkColors.push(val[pkey].upd.ink_id);
          }
          else {
            tmpArr[key] = { inkColors: [val[pkey].upd.ink_id] };
          }
        }
      );
    });
    return tmpArr;
  }

  isObjectEmpty(card) {
    return (!card || Object.keys(card).length === 0) ? true : false;
  };

  checkQty(enterdQty, allowedQty, type, sizeIndex, colorId, productId) {
    if ((type === 'custom' || type === 'quickItem') && (allowedQty === '' || allowedQty === null)) {
      return false;
    }
    else {
      let totalBalance = 0;
      let isproducExist = false;
      if (this.projects.projects_data.length > 1) {
        for (let i = 0; i < this.projects.projects_data[this.activeProjectIndex].length; i++) {
          if (this.projects.projects_data[i].products && this.projects.projects_data[i].products != undefined && this.projects.projects_data[i].products.length > 0) {
            let products = this.projects.projects_data[i].products.find(x => x.product_id === productId);
            if (products) {
              for (let m = 0; m < products.matrix.length; m++) {
                if (products.matrix[m].color.color_id == colorId) {
                  isproducExist = true;
                  totalBalance += products.matrix[m].quantity[sizeIndex];
                }
                else {
                  isproducExist = false;
                  totalBalance = 0;
                }
              }
            }
          }
        }
      }
      let totalEnteredQty = isproducExist == true ? totalBalance : enterdQty;
      if ((totalEnteredQty > allowedQty)) {
        return true;
      }
      else {
        return false;
      }
    }
  }

  showConfirmMessage() {
    if (this.grandTotalPrice > 0 && this.prevPrice != this.grandTotalPrice) {
      localStorage.setItem("isorder", 'yes');
    }
  }

  calculatePricePerPiece(priceMarkupData, productId, colorId, sizeId, totalPrintingPrice, totalQty, qtyPerSize) {
    let totalPricePerPiece = 0;
    if (priceMarkupData != '' && qtyPerSize > 0) {
      let priceMarkup = (priceMarkupData[productId] && priceMarkupData[productId][colorId] && priceMarkupData[productId][colorId][sizeId] && priceMarkupData[productId][colorId][sizeId].priceMarkup) ? priceMarkupData[productId][colorId][sizeId].priceMarkup : 0;
      let perPiecePrintPrice = totalPrintingPrice > 0 ? totalPrintingPrice / totalQty : 0;
      let perPiecePriceMarkup = priceMarkup > 0 ? priceMarkup / qtyPerSize : priceMarkup;
      let totalPricePerPiece = this.numRoundToPlace((perPiecePriceMarkup), 2);
      return totalPricePerPiece;
    }
    else {
      return totalPricePerPiece;
    }
  }

  calculateTotalPrice(priceMarkupData, productId, colorId, sizeId, totalPrintingPrice, totalQty, qtyPerSize, qty, impression) {
    let totalPrice = 0;
    if (priceMarkupData != '' && qtyPerSize > 0) {
      let priceMarkup = (priceMarkupData[productId] && priceMarkupData[productId][colorId] && priceMarkupData[productId][colorId][sizeId] && priceMarkupData[productId][colorId][sizeId].priceMarkup) ? priceMarkupData[productId][colorId][sizeId].priceMarkup : 0;
      let totalPricePerPiece = priceMarkup > 0 ? priceMarkup / qtyPerSize : priceMarkup;
      totalPrice = (totalPricePerPiece) + (impression);
      return this.numRoundToPlace((totalPrice), 2);
    }
    else {
      return totalPrice;
    }
  }

  numRoundToPlace(num, dec) {
    if ((typeof num !== 'number') || (typeof dec !== 'number'))
      return false;

    var num_sign = num >= 0 ? 1 : -1;
    return (Math.round((num * Math.pow(10, dec)) + (num_sign * 0.0001)) / Math.pow(10, dec)).toFixed(dec);
  }

  calculateInventory(enteredQty, inStockQty, sizeIndex, colorId, productId) {
    let totalBalance = 0;
    let isproducExist = false;
    if (this.projects.projects_data.length > 1) {
      for (let i = 0; i < this.projects.projects_data[this.activeProjectIndex].length; i++) {
        if (this.projects.projects_data[i].products && this.projects.projects_data[i].products != undefined && this.projects.projects_data[i].products.length > 0) {
          let products = this.projects.projects_data[i].products.find(x => x.product_id === productId);
          if (products) {
            for (let m = 0; m < products.matrix.length; m++) {
              if (products.matrix[m].color.color_id == colorId) {
                isproducExist = true;
                totalBalance += products.matrix[m].quantity[sizeIndex];
              }
              else {
                isproducExist = false;
                totalBalance = 0;
              }
            }
          }
        }
      }
    }
    if (inStockQty != '') {
      let totaEnteredQty = isproducExist == true ? totalBalance : enteredQty;
      return (inStockQty - totaEnteredQty);
    }
    else {
      return 0;
    }
  }

  getProductMatrix = function (catalogue) {
    this.loading = true;
    if (catalogue == 'all') {
      this.productOptions = {
        id: localStorage.getItem("userID")
      };
    } else {
      this.productOptions = {
        id: localStorage.getItem("userID"),
        provider: catalogue
      };
    }
    this.CommonService.apiService(
      "POST",
      "order/get_matrix",
      this.productOptions
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          this.CommonProjectDataService.storeProductMatrix(response.data);
          this.productMatrix = this.CommonProjectDataService.getProductMatrix();
        }
      },
      err => {
        console.log(err);
      }
    );
    this.loading = false;
  };

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  }

  SetSelectedValue(pikey, pmkey, matrix_id) {
    if (this.projects.projects_data[this.activeProjectIndex]['products'][pikey].matrix[pmkey].matrix_id == matrix_id) {
      this.selectedMatrix_id = matrix_id;
    }
    return matrix_id;
  }

  getMinQty = function () {
    this.loading = true;
    this.productOptions = {
      id: localStorage.getItem("userID"),
      provider: 'all'
    };
    this.CommonService.apiService(
      "POST",
      "products/filters",
      this.productOptions
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          this.productFilters = response.data;
          this.CommonProjectDataService.storeMinOrderQty(response.data.min_order_qty);
        }
      },
      err => {
        console.log(err);
      }
    );
  };

  isAccessInvoiceType() {
    const hasOrderType = this.CommonProjectDataService.getOrderType();
    const isInvoiceEditable = this.CommonProjectDataService.getIsInvoiceEditable();
    const isRedirectUrl = this.settingService.isAccessInvoiceType(hasOrderType, this.isPublicQuoteCreation, isInvoiceEditable);
    if (isRedirectUrl) {
      return this.router.navigate([isRedirectUrl]);
    }
  }

  getKeys(obj: any): string[] {
    return Object.keys(obj);
  }  

}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-invoices/product-quantity/product-quantity.component.ts